import React, { Component } from 'react'
import i18n from 'i18next'
import HoverInfo from '../../UniformComponents/HoverInfo'
import Select from '../../components/form/Select'

import TA_ICON from '../../assets/images/ta_icon.svg'
import OD_ICON from '../../assets/images/od_icon.svg'
import '../question-builder.scss'

export default class QuestionPicker extends Component {
    constructor(props) {
        super(props)
        this.questionTypes = [
            {
                type: 'RD',
                icon: 'fa-light fa-list-radio',
            },
            {
                type: 'CH',
                icon: 'fa-light fa-list-check',
            },
            {
                type: 'SB',
                icon: 'fa-light fa-list-dropdown',
            },
            {
                type: 'TX',
                icon: 'fa-light fa-input-pipe',
            },
            {
                type: 'TA',
                isImg: true,
                icon: TA_ICON,
            },
            {
                type: 'TL',
                icon: 'fa-light fa-rectangle-list',
            },
            {
                type: 'TB',
                icon: 'fa-light fa-table-list',
            },
            {
                type: 'OD',
                isImg: true,
                icon: OD_ICON,
            },
            {
                type: 'PC',
                icon: 'fa-light fa-slider',
            },
            {
                type: 'I',
                icon: 'fa-light fa-input-numeric',
            },
            {
                type: 'NF',
                icon: 'fa-light fa-list-ol',
            },
            {
                type: 'DT',
                icon: 'fa-light fa-calendar-days',
            },
            {
                type: 'FM',
                icon: 'fa-light fa-pen-field',
            },
            {
                type: 'ST',
                icon: 'fa-light fa-input-text',
            },
            {
                type: 'UV',
                icon: 'fa-light fa-globe',
                link: 'https://kb.explori.com/knowledge/adding-a-url-variable-question-to-your-survey-new',
            },
            {
                type: 'SG',
                icon: 'fa-light fa-grid-2-plus',
            },
        ]

        const { disabled, value, options } = this.props
        this.questionTypes = this.questionTypes
            .filter((q) => (disabled ? (value === q.type) : options.includes(q.type)))
    }

    onKeyDown(e, questionType) {
        const { onChange, disabled, value } = this.props
        if (disabled || value === questionType) return
        if (e.keyCode === 13) {
            onChange(questionType)
        }
    }

    handleChange = (questionType) => {
        const { onChange, disabled, value } = this.props
        if (disabled || value === questionType) return
        onChange(questionType)
    }

    renderCard = (questionType, ind) => {
        const { disabled, value } = this.props
        const selectedClass = value === questionType.type ? 'selected' : ''
        const disabledClass = disabled ? 'disabled' : ''
        return (
            <div
                role="button"
                tabIndex={0}
                className={`que-picker ${selectedClass} ${disabledClass}`}
                onClick={() => { this.handleChange(questionType.type) }}
                onKeyDown={(e) => { this.onKeyDown(e, questionType.type) }}
            >
                <HoverInfo
                    cssClass={`hover-info right-${ind % 4}`}
                    desc={i18n.t(`questionType.info.${questionType.type}`)}
                    dir="bottom"
                    href={questionType.link || 'http://kb.explori.com/knowledge'}
                    target="_blank"
                    isExternal
                >
                    <i className="info-icon fa-light fa-circle-info" />
                </HoverInfo>
                {questionType.isImg ? <img src={questionType.icon} alt="que-icon" /> : <i className={`que-icon ${questionType.icon}`} />}
                <p className="que-name">{i18n.t(`questionType.${questionType.type}`)}</p>
            </div>
        )
    }

    renderCardsComponent = () => (
        <div id="que-picker-container">
            {
                this.questionTypes.map((questionType, ind) => (
                    this.renderCard(questionType, ind)
                ))
            }
        </div>
    )

    renderSelectComponent = () => {
        const { value } = this.props
        const selectOptions = this.questionTypes.map((qt) => ({
            label: i18n.t(`questionType.${qt.type}`),
            value: qt.type,
            src: qt.icon,
            isIcon: !qt.isImg,
            iconLeft: true,
        }))

        return (
            <Select
                key={value}
                name="questionType"
                label={i18n.t('q_type')}
                options={selectOptions}
                defaultValue={value}
                onBlur={(e) => this.handleChange(e.value)}
                isMandatory
                isSearchable
            />
        )
    }

    render() {
        const { showAsDropdown } = this.props
        return showAsDropdown ? this.renderSelectComponent() : this.renderCardsComponent()
    }
}
